import { Checkbox } from "antd";
import React, { useState, useEffect, useContext } from "react";
import AddToCart from "../../components/AddToCart/AddToCart";
import PopupNotes from "../../components/PopupNotes/PopupNotes";
import SmallModal from "../../components/SmallModal/SmallModal";
import { VILLAGES_OBJ } from "../../constants/constants";
import { AppContext } from "../../context";
import { openkit } from "../../library/database";
import { addBikeToCart } from "./addBikeToCart";
import RentabikeReservationInfo from "./RentabikeReservationInfo";

function RentabikeCardContent({
  product,
  context,
  setIsAddedToCartVisible,
  setAddedToCart,
  clientRequest,
}) {
  const [isPriceModalVisible, setIsPriceModalVisible] = useState(false);
  const [extraReservationConfig, setExtraReservationConfig] = useState([]);
  const info = useContext(AppContext);

  const selectComponent = () => {
    switch (context) {
      case undefined:
        return (
          <>
            <div className="card-body">
              <div className="short-description">
                {product?.gen_description["pt-pt"]}
              </div>
            </div>
          </>
        );
      case "reservation-info":
        return (
          <div className="ahp-reservation-content">
            <RentabikeReservationInfo product={product} />

            <AddToCart
              setIsAddedToCartVisible={setIsAddedToCartVisible}
              handleAddToCart={() =>
                addBikeToCart(
                  product,
                  info,
                  extraReservationConfig,
                  clientRequest,
                  setAddedToCart
                )
              }
            />
          </div>
        );
      case "cart":
        return (
          <div className="ahp-reservation-content">
            <RentabikeReservationInfo product={product} />

            <PopupNotes notes={product.request} />
          </div>
        );
      case "reservation":
      case "ticket":
      case "payment":
        return (
          <div className="ahp-reservation-content">
            <RentabikeReservationInfo product={product} />
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <div>
      {product?.gen_price !== null &&
        product?.gen_price !== 0 &&
        context !== "ticket" &&
        context !== "reservation-info" &&
        context !== "payment" &&
        !(
          product?.status === "not-available" ||
          product?.status === "not-defined"
        ) && (
          <div className="ahp-price">
            <div className="ahp-price-value">
              {product?.gen_price || product.total_price} €
            </div>
            <div
              className="ahp-price-info"
              onClick={() => setIsPriceModalVisible(true)}
            >
              i
            </div>
          </div>
        )}
      {selectComponent()}
      <SmallModal
        text="Preço por dia."
        isPriceModalVisible={isPriceModalVisible}
        setIsPriceModalVisible={setIsPriceModalVisible}
        width="200px"
      />
    </div>
  );
}

export default RentabikeCardContent;
